var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9808184-6b3b-4d44-9c63-ae8fd0bccfb3",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.89 181.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.f16027e2-7ada-4261-93c5-5dabdbf23b11{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.f16027e2-7ada-4261-93c5-5dabdbf23b11{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f74a56ac-1f5a-4a93-b484-da36f32ca8d2",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M384.7,9.09,351.26,28.93a4,4,0,0,0-2,3.44V76a4,4,0,0,1-1.94,3.44l-32,19.19a4,4,0,0,1-2.06.57L24.4,98.53a4.05,4.05,0,0,0-2,.55l-10.2,6a4,4,0,0,0-2,3.44v64.81"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "f0242ded-f249-4b81-ad0d-c8b8d79a59f9",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M384.7,9.09,351.26,28.93a4,4,0,0,0-2,3.44V76a4,4,0,0,1-1.94,3.44l-32,19.19a4,4,0,0,1-2.06.57L24.4,98.53a4.05,4.05,0,0,0-2,.55l-10.2,6a4,4,0,0,0-2,3.44v64.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f16027e2-7ada-4261-93c5-5dabdbf23b11",
    d: "M384.7,9.09,351.26,28.93a4,4,0,0,0-2,3.44V76a4,4,0,0,1-1.94,3.44l-32,19.19a4,4,0,0,1-2.06.57L24.4,98.53a4.05,4.05,0,0,0-2,.55l-10.2,6a4,4,0,0,0-2,3.44v64.81"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.9c7c0759.svg";
export { ForwardRef as ReactComponent };